import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { NavigationService, NavItem } from '../../../core/services/navigation.service';

@Component({
    selector: 'app-feature-tabs',
    standalone: true,
    imports: [CommonModule, RouterModule],
    templateUrl: './feature-tabs.component.html',
    styleUrl: './feature-tabs.component.scss'
})
export class FeatureTabsComponent {
    navService = inject(NavigationService);
    router = inject(Router);

    constructor() {
        // Publish the strip height so sticky page headers can sit below it.
        this.publishHeight();
        this.router.events
            .pipe(filter((e) => e instanceof NavigationEnd))
            .subscribe(() => this.publishHeight());
    }

    private publishHeight(): void {
        const h = this.navService.getTabsForActiveCategory().length > 0 ? '44px' : '0px';
        document.documentElement.style.setProperty('--zf-tabs-h', h);
    }

    get tabs(): NavItem[] {
        return this.navService.getTabsForActiveCategory();
    }

    get showTabs(): boolean {
        return this.tabs.length > 0;
    }

    isActive(item: NavItem): boolean {
        const currentUrl = this.router.url.split('?')[0];
        const fullUrl = this.router.url;

        if (item.queryParams?.tab) {
            return fullUrl.includes(`tab=${item.queryParams.tab}`);
        }

        // If it's the base route and there are no other specific matches with query params
        if (item.route === currentUrl && !fullUrl.includes('tab=')) return true;

        // Also check subroutes
        return item.subRoutes?.some(sr => currentUrl.startsWith(sr)) || false;
    }
}
